import { withStyles } from '@material-ui/core';
import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { Claim, getClaim } from '../../../../../claim';
import { ExpansionPanel } from '../../../../../forms/form-components/expansion-panel/expansion-panel';
import { State } from '../../../../../redux/root-reducer';
import { getObjectWarning } from '../../../../../shared-functions';
import styles, { StyledComponent } from '../../../../../styles/styles';
import { PersonalDetailsView } from './personal-details';

type Props = StyledComponent & {
    claim: Claim;
};
const lifeAssuredView: React.FunctionComponent<Props> = ({ claim }: Props) => {
    let notifier;
    if (claim.validationErrors && claim.validationErrors.includes('LifeAssuredDetails')) {
        notifier = getObjectWarning(claim.validationErrors, claim.validationErrors);
    }
    return (
        <ExpansionPanel name="LifeAssuredDetails" notifier={notifier}>
            <PersonalDetailsView />
        </ExpansionPanel>
    );
};

const mapStateToProps = (state: State) => ({
    claim: getClaim(state),
});

export const LifeAssuredView = connect(mapStateToProps, {})(withStyles(styles)(lifeAssuredView));
